<template>
  <div>
    <div class="columns is-multiline mgt-20px">
      <div class="column is-12 pdb-0">
        <div class="card">
          <div class="pd-10px">
            {{ $t('general.creatednBy', {
            user: getUser(data.creatorUserId),
            date: getDate(data.creationTime),
          }) }}
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="card"
            v-if="data.lastModifierUserId || data.lastModificationTime">
          <div class="pd-10px">
            {{ $t('general.lastModificationBy', {
            user: getUser(data.lastModifierUserId),
            date: getDate(data.lastModificationTime),
          }) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatDate';
import { createNamespacedHelpers } from 'vuex';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'informationCreateUpdateUser',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getUser(userId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((user) => {
          return user.id === userId;
        });
      return userFind ? userFind.decorator.nomPrenom : this.$i18n.t('general.inconnu');
    },
    getDate(date) {
      return formatDate(date);
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
